import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

import styles from 'assets/jss/material-dashboard-pro-react/components/customLinearProgressStyle.js';

const useStyles = makeStyles(styles);

type LinearProgressColor = 'primary' | 'warning' | 'danger' | 'success' | 'info' | 'rose' | 'gray';

interface ILinearProgress {
	color?: LinearProgressColor;
	value?: number;
	variant?: 'determinate' | 'indeterminate' | 'buffer' | 'query';
	className?: string;
}

const CustomLinearProgress = (props: ILinearProgress) => {
	const classes = useStyles();
	const { color = 'gray', ...rest } = props;
	const backgroundColor = color + 'Background';
	return (
		<LinearProgress
			{...rest}
			classes={{
				// @ts-ignore
				root: classes.root + ' ' + classes[backgroundColor],
				bar: classes.bar + ' ' + classes[color],
			}}
		/>
	);
};
export default CustomLinearProgress;
